export enum SubscriptionState {
    Deleted,
    Disabled,
    Enabled,
    PastDue,
    Warned
}

export enum SpendingLimit {
    CurrentPeriodOff,
    Off,
    On
}

export interface SubscriptionPolicies {
    /**
     * The subscription location placement ID. The ID indicates which regions are visible for a subscription.
     * For example, a subscription with a location placement Id of Public_2014-09-01 has access to Azure public regions.
     */
    locationPlacementId: string;

    /**
     * The subscription quota ID.
     */
    quotaId: string;

    /**
     * The subscription spending limit.
     */
    spendingLimit: SpendingLimit;
}

export interface Subscription {
    /**
     * The authorization source of the request.
     * Valid values are one or more combinations of Legacy, RoleBased, Bypassed, Direct and Management.
     * For example, 'Legacy, RoleBased'.
     */
    authorizationSource: string;

    /**
     * The subscription display name.
     */
    displayName: string;

    /**
     * The fully qualified ID for the subscription. For example, /subscriptions/00000000-0000-0000-0000-000000000000.
     */
    id: string;

    /**
     * The subscription state. Possible values are Enabled, Warned, PastDue, Disabled, and Deleted.
     */
    state: SubscriptionState;

    /**
     * The subscription ID.
     */
    subscriptionId: string;

    /**
     * The subscription policies.
     */
    subscriptionPolicies: SubscriptionPolicies;
}

/**
 * Subscription list operation response.
 */
export interface SubscriptionListResult {
    /**
     * The URL to get the next set of results.
     */
    nextLink: string;

    /**
     * An array of subscriptions.
     */
    value: Subscription[];
}

/**
 * Custom response to list all subscriptions.
 */
export interface SubscriptionsOperationResult {
    /**
     * The http status code.
     */
    httpStatusCode: number;

    /**
     * The subscription list.
     */
    value?: SubscriptionListResult;
}
